import mutations from './user/mutations';
import actions from './user/actions';
import getters from './user/getters';

import config from '@/config/config';

const user = {
  namespaced: true,
  state: {
    user: {
      token: null,
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      confirmationToken: null,
      invitationCode: null,
    },
    currentCourse: config.initial.course.start,
    currentLectureIndex: 0,
    currentPassword: null,
    setIsLoading: false,
    courses: [],
    course: null,
    invitations: [],
    errors: [],
  },
  getters,
  mutations,
  actions,
};

export default user;
